var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{ref:"progress-table",attrs:{"table-ref":"progesstable","title":_vm.permitLabel + ' Report',"icon":"fa fa-file","url":"/view/actions/prg","fields":_vm.fields,"sort-field":"siteName","layer-component":"progress","layer-args":{ id: 'id' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }